module.exports = __webpack_public_path__ + "static/img/7.7f23457.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/snip3down/7.png
// module id = YikH
// module chunks = 35